import React from 'react';
import {FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import ReactSelect from 'react-select';

export class SelectAsync extends React.Component {
  render() {
    const {
      input,
      label,
      required,
      placeholder,
      loadOptions,
      creatable,
      helpText,
      meta: {error, warning, touched},
      ...props
    } = this.props;

    let errorMessage;
    const validationState = (touched && error && 'error') || (warning && 'warning') || null;

    if (touched && (error || warning)) {
      errorMessage = <span className="help-block">{error || warning}</span>;
    }

    let placeholderText = 'Type to search';
    if (placeholder !== undefined) {
      placeholderText = placeholder;
    }

    const asterisk = (required && <span className="form-field-required" />) || null;

    const Component = creatable ? ReactSelect.AsyncCreatable : ReactSelect.Async;

    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>
          {label}
          {asterisk}
        </ControlLabel>
        <Component
          {...{
            ...input,
            value: input.value,
            onBlur: () => input.onBlur(input.value),
            loadOptions,
            placeholder: placeholderText,
            ...props,
          }}
        />
        {helpText && <span className="help-text">{helpText}</span>}
        {errorMessage}
        <FormControl.Feedback />
      </FormGroup>
    );
  }
}
